import React from 'react'
import { format } from 'date-fns'
import popup from '~/views/Popup/popup'

import amexImg from '~/views/Popup/views/CreateSubscription/images/amex.png'
import discoverImg from '~/views/Popup/views/CreateSubscription/images/discover.png'
import mastercardImg from '~/views/Popup/views/CreateSubscription/images/mastercard.png'
import visaImg from '~/views/Popup/views/CreateSubscription/images/visa.png'

const paymentsMap = {
  amex: amexImg,
  discover: discoverImg,
  mastercard: mastercardImg,
  visa: visaImg
}

export default class ActiveSubscriptionInfo extends React.Component {
  error(){
    console.log('error')
  }

  render() {
    const { subscription } = this.props
    const { platform, paymentHandlerDisplayName } = subscription.subscriptionInfo;
    const ifSubscribedViaWeb = platform.indexOf('web') !== -1
    var spi = (subscription && subscription.subscriptionPlanInfo) || {}
    var si = (subscription && subscription.subscriptionInfo) || {}

    return (
      <section>
        <div className="title site-color">Subscription</div>
        <div className="detail">
          <div className="title site-color">Subscription Plan</div>
          <div className="main">
            <div className="key">{ spi && spi.name }</div>

            { spi.renewable && (<div className="next-step">
              Next billing date: <br />
              { format(si.subscriptionEndDate, 'MM-DD-YYYY') }
            </div>) }
          </div>

            <div className="buttons">
              { spi.renewable && subscription.plans.length > 0 && (
                <div className="button" onClick={ _ => ifSubscribedViaWeb ? popup.upgradeSubscription() : popup.error(paymentHandlerDisplayName) }>Upgrade Plan</div>
              ) }
              { spi.renewable && (
                <div className="button" onClick={ _ => ifSubscribedViaWeb ? popup.cancelSubscription() : popup.error(paymentHandlerDisplayName) }>Cancel Subscription</div>
              ) }
            </div>

        </div>
        <div className="clearfix"></div>
        <div className="detail">
          <div className="title site-color">Payment Processor</div>
          <div className="main">
            <span>
              {(subscription && si && si.brand) && <img
                alt="Payment"
                className="payment-card"
                src={paymentsMap[si.brand.toLowerCase()]}
                role="presentation"/>}
            </span>
            <span>
              { si.last4 ?  ('**** **** **** ' + si.last4) :  si.paymentHandler }
            </span>
          </div>
          <div className="buttons">
            { spi.renewable && (si.paymentHandler === 'STRIPE') && (
              <div
                className="button"
                onClick={ _ => ifSubscribedViaWeb ? popup.updateStripePayment() : popup.error(paymentHandlerDisplayName) }>
                Update Billing
              </div>
            ) }
            <div className="button" onClick={ _ => popup.billingHistory() }>Billing History</div>
          </div>
        </div>
        <div className="clearfix"></div>
      </section>)
  }
}
